import React, { useState } from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Breadcrumbs,
} from "@mui/material";
import { LocalActivity, Recycling } from "@mui/icons-material";
import { ThemeProvider } from "@mui/material/styles";
import { DailyPayRun } from "./PayrollProcessing/DailyPayRun";
import { PayrollCycleRun } from "./PayrollProcessing/PayrollCycleRun";
import { themes, theme, sideBarWidth } from "services/constants";
import { useSelector, useDispatch } from "react-redux";
import { PayrunCycleProvider } from "./PayrollProcessing/PayrollCycleRun/PayrollCycleRunContext";
import { FilterProvider } from "pages/FilterContext";
import { setFilterApi } from "services/Redux/userManagament";

export const PayrollProcessing = () => {
  const [selectPayrollProcessingItem, setSelectPayrollProcessingItem] =
    useState("Daily Payrun");
  const shiftSidebarOpen = true;
  const { domain, userScreenAccess, userDetails } = useSelector(
    (state) => state.tokenReducer
  );
  const [isClickSchedule, setIsClickSchedule] = useState(false);
  const dispatch = useDispatch();

  const shiftModule = userScreenAccess?.module_details?.find(
    (mod) => mod.module_name === "Payroll Processing"
  );

  const subModuleId = shiftModule?.submodules?.find(
    (sub) => sub.sub_module_name === selectPayrollProcessingItem
  )?.sub_module_id;

  const shiftMenuItems = [
    {
      type: "item",
      title: "Daily Payrun",
      key: "Daily Payrun",
      subtitle: "Process daily payroll",
      icon: <LocalActivity />,
      color: "#6c757d",
    },

    {
      type: "item",
      title: "Cycle Pay Run",
      key: "Payroll Cycle Run",
      subtitle: "Process payroll cycle",
      icon: <Recycling />,
      color: "#6c757d",
    },
  ];

  const handlePayrollItemClick = (itemTitle) => {
    if (selectPayrollProcessingItem === itemTitle) return;
    setSelectPayrollProcessingItem(itemTitle);
    dispatch(setFilterApi(true));
  };

  const renderMainContent = () => {
    switch (selectPayrollProcessingItem) {
      case "Daily Payrun":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <DailyPayRun />
          </FilterProvider>
        );
      case "Payroll Cycle Run":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <PayrunCycleProvider>
              <PayrollCycleRun setIsClickSchedule={setIsClickSchedule} />
            </PayrunCycleProvider>
          </FilterProvider>
        );
      default:
        return <DailyPayRun />;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          height:
            selectPayrollProcessingItem === "Payroll Cycle Run"
              ? "115vh"
              : "94.5vh",
          backgroundColor: themes?.whiteColor,
        }}
      >
        <Box
          sx={{
            width: shiftSidebarOpen ? sideBarWidth : 0,
            transition: "width 0.3s ease",
            overflowX: "hidden",
            flexShrink: 0,
            mt: "10px",
            backgroundColor: themes?.whiteColor,
            borderRight: "1px solid #f5f5fd",
          }}
        >
          <List sx={{ p: 2 }}>
            {shiftMenuItems.map((item, index) =>
              item.type === "tile" ? (
                <Typography
                  key={`tile-${index}`}
                  variant="subtitle"
                  sx={{ fontWeight: 700, color: "#00D4AA", mt: 2, mb: 2 }}
                >
                  {item.title}
                </Typography>
              ) : (
                <ListItem key={item.title} disablePadding sx={{ mb: 1, mt: 1 }}>
                  <ListItemButton
                    onClick={() => handlePayrollItemClick(item.key)}
                    sx={{
                      backgroundColor:
                        selectPayrollProcessingItem === item.key
                          ? "#f0f8ff"
                          : "transparent",
                      borderRadius: 1,
                      p: 1,
                      "&:hover": { backgroundColor: "#f8f9fa" },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: "38px",
                        color:
                          selectPayrollProcessingItem === item.key
                            ? "#00D4AA"
                            : item.color,
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        {item.title}
                      </Typography>
                      <Typography variant="caption" sx={{ fontWeight: 600 }}>
                        {item.subtitle}
                      </Typography>
                    </Box>
                  </ListItemButton>
                </ListItem>
              )
            )}
          </List>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            p: 3,
            minWidth: 0,
            backgroundColor: "#f5f5fd",
            transition: "all 0.3s ease",
          }}
        >
          {shiftSidebarOpen && !isClickSchedule && (
            <Breadcrumbs aria-label="breadcrumb" separator="›" sx={{ mb: 2 }}>
              <Typography>Payroll</Typography>
              <Typography>Operations</Typography>
              <Typography>Payroll Processing</Typography>
              <Typography color={themes?.blueColor}>
                {selectPayrollProcessingItem}
              </Typography>
            </Breadcrumbs>
          )}

          {renderMainContent()}
        </Box>
      </Box>
    </ThemeProvider>
  );
};
